<template>
  <div class="home">
    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <h1 class="titillium-web-bold">Tarefa Solidária Jogos Interclasse</h1>
          <h4 class="titillium-web-light">Resultado Final</h4>
        </div>
        <div class="row pt-4">
            <div class="col-3" v-for="(quantidade, produto) in produtosQuantidades" :key="produto">
              <!-- Exibição do produto e sua quantidade -->
              <div class="holder-salas " >
                <div class="sala titillium-web-bold text-center pt-2" style="font-size: 14px;">
                  {{ produto }}
                </div>
                <div class="porcentagem text-center titillium-web-bold pt-2"> {{ trataDonate(produto, quantidade) }}</div>
                <div class="percent-donate green-bg" style="height: 100%;">

                </div>
                <!-- <p>{{ produto }}: {{ quantidade }} - {{ trataDonate(produto, quantidade) }}</p> -->
              </div>

            </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $firebase } from '../services/firebase'

export default {
  data() {
    return {
      server: "http://localhost:8080",
      email: "",
      password: "",
      loading: false,
      error: false,
      msg_error: "",
      produtosQuantidades: {} // Variável para armazenar os produtos e suas quantidades
    };
  },
  methods: {
    async consultarProdutosQuantidades() {
      try {
        // Referência para a tabela 'donates'
        const donatesRef = $firebase.database().ref('donates');

        // Consulta para obter todos os produtos e suas quantidades
        const snapshot = await donatesRef.once('value');

        // Objeto para armazenar os produtos e suas quantidades
        const produtosQuantidades = {};

        // Iterar sobre os dados retornados pela consulta
        snapshot.forEach(classeSnapshot => {
          classeSnapshot.forEach(dateSnapshot => {
            dateSnapshot.forEach(idSnapshot => {
              const produto = idSnapshot.val().produto;
              const quantidade = idSnapshot.val().quantidade;

              // Adicionar o produto e sua quantidade ao objeto
              if (produtosQuantidades[produto]) {
                produtosQuantidades[produto] += quantidade;
              } else {
                produtosQuantidades[produto] = quantidade;
              }
            });
          });
        });

        // Atualizar a variável com os produtos e suas quantidades
        this.produtosQuantidades = produtosQuantidades;

        // Log dos produtos e suas quantidades
        console.log('Produtos e suas quantidades:', this.produtosQuantidades);
      } catch (error) {
        console.error('Erro ao obter os produtos e suas quantidades:', error);
      }
    },
    trataDonate(produto , quantidade){
      var newQtd 
      var unidadeMedida
      if(produto === 'Água Sanitária - 1 Litro'){
        newQtd = quantidade
        unidadeMedida = "L"
      }else if(produto === 'Desinfetante – 500 ml'){
        newQtd = quantidade
        unidadeMedida = "L"
      }else if(produto === 'Fralda Infantil – M e G'){
        newQtd = quantidade
        unidadeMedida = "unidades"

      }else if(produto === 'Detergente – 500ml'){
        newQtd = quantidade
        unidadeMedida = "L"

      }else if(produto === 'Fralda XG Adulto'){
        newQtd = quantidade
        unidadeMedida = "unidades"

      }else if(produto === 'Sabão em pó – 800g'){
        newQtd = quantidade
        unidadeMedida = "Kg"


      }else if(produto === 'Feijão – 1kg'){
        newQtd = quantidade
        unidadeMedida = "Kg"

      }else if(produto === 'Leite de caixa Integral – 1 Litro'){
        newQtd = quantidade
        unidadeMedida = "L"

      }else if(produto === 'Óleo – 900ml'){
        newQtd = quantidade
        unidadeMedida = "L"

      }else if(produto === 'Açucar - 2kg'){
        newQtd = quantidade
        unidadeMedida = "Kg"


      }else if(produto === 'Arroz – 5Kg'){
        newQtd = quantidade
        unidadeMedida = "Kg"


      }else if(produto === 'Macarrão – 500g'){
        newQtd = quantidade
        unidadeMedida = "Kg"


        
      }




      return newQtd+' '+unidadeMedida
    }
  },
  async mounted() {
    // Chamar o método para consultar os produtos e suas quantidades quando o componente é montado
    await this.consultarProdutosQuantidades();
  }

};
</script>
